<template>
  <div class="mall-category-tabs">
    <div class="mall-category-tabs__inner">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        ref="tabs"
        class="mall-category-tabs__tab"
        :class="{ 'mall-category-tabs__tab--active': tab.key === value }"
        @click="$emit('change', tab.key)"
      >
        {{ tab.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallCategoryTabs',
  props: {
    // [{ key, label }]
    tabs: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  watch: {
    value() {
      this.$nextTick(this.scrollToActive)
    },
  },
  methods: {
    // 선택한 탭의 이전 탭이 왼쪽 끝에 오도록 가로 스크롤 이동 (Figma 기준)
    scrollToActive() {
      var index = this.tabs.findIndex(tab => tab.key === this.value)
      var prev = this.$refs.tabs && this.$refs.tabs[index - 1]
      var left = prev ? prev.offsetLeft - 16 : 0
      if (this.$el.scrollTo) {
        this.$el.scrollTo({ left: left, behavior: 'smooth' })
      } else {
        this.$el.scrollLeft = left
      }
    },
  },
}
</script>

<style scoped>
.mall-category-tabs {
  position: relative;
  border-bottom: 1px solid #E5E8EB;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.mall-category-tabs::-webkit-scrollbar {
  display: none;
}

.mall-category-tabs__inner {
  display: flex;
  width: max-content;
  padding: 0 16px;
  gap: 8px;
}

.mall-category-tabs__tab {
  position: relative;
  padding: 12px;
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
  cursor: pointer;
}

.mall-category-tabs__tab--active {
  color: var(--color-text-main);
  font-weight: var(--font-weight-semibold);
}

.mall-category-tabs__tab--active::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  background: var(--color-text-main);
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallCategoryTabs.vue